import { render, staticRenderFns } from "./vulDetectionTrend.vue?vue&type=template&id=19bf82fe&scoped=true"
import script from "./vulDetectionTrend.vue?vue&type=script&lang=js"
export * from "./vulDetectionTrend.vue?vue&type=script&lang=js"
import style0 from "./vulDetectionTrend.vue?vue&type=style&index=0&id=19bf82fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bf82fe",
  null
  
)

export default component.exports